import { useState } from 'react'
import { Loader as SpinnerIcon } from 'lucide-react'
import { useActiveJobs } from '../context/ActiveJobsContext'
import { DeviceOperationModal } from './device-operation'

export default function ActiveJobIndicator() {
  const { activeJobs, removeJob, selectedJobId, setSelectedJobId } = useActiveJobs()
  const [minimizedJobId, setMinimizedJobId] = useState<string | null>(null)

  if (activeJobs.length === 0) {
    return null
  }

  const selectedJob = selectedJobId
    ? activeJobs.find((job) => job.commandId === selectedJobId)
    : activeJobs[0]

  const handleIndicatorClick = () => {
    if (selectedJob) {
      setSelectedJobId(selectedJob.commandId)
      setMinimizedJobId(null)
    }
  }

  const handleIndicatorKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleIndicatorClick()
    }
  }

  const handleComplete = () => {
    if (selectedJob) {
      removeJob(selectedJob.commandId)
    }
    setMinimizedJobId(null)
    setSelectedJobId(null)
  }

  const handleMinimize = () => {
    if (selectedJobId) {
      setMinimizedJobId(selectedJobId)
    }
  }

  const jobLabel = activeJobs.length === 1
    ? (activeJobs[0].type === 'supervise' ? 'Installing...' : 'Uninstalling...')
    : `${activeJobs.length} jobs`

  return (
    <>
      <div
        onClick={handleIndicatorClick}
        onKeyDown={handleIndicatorKeyDown}
        tabIndex={0}
        role="button"
        aria-label={`${activeJobs.length} active job${activeJobs.length !== 1 ? 's' : ''}. Click to view progress.`}
        className="fixed bottom-6 right-6 z-40 flex items-center gap-3 px-4 py-3 bg-brand text-white rounded-full shadow-lg hover:bg-brand-hover active:scale-95 transition-all cursor-pointer select-none"
      >
        <SpinnerIcon size={20} className="motion-safe:animate-spin" />
        <span className="text-sm font-medium">{jobLabel}</span>
        <span className="sr-only">Loading</span>
      </div>

      {selectedJobId && minimizedJobId !== selectedJobId && selectedJob && (
        <DeviceOperationModal
          mode={selectedJob.type === 'supervise' ? 'install' : 'uninstall'}
          existingJob={selectedJob}
          onClose={handleMinimize}
          onComplete={handleComplete}
          deviceId={selectedJob.deviceId ?? undefined}
          deviceName={selectedJob.deviceName}
        />
      )}
    </>
  )
}
